import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('admin', [
      'fetch',
      'create',
      'update',
      'listGroups',
      'action',
      'lookup',
      'getDetail',
      'templateUpload',
      'upload',
      'downloadList',
    ]),

    async getGroups() {
      const groups = await this.listGroups();
      const temp = {};
      for (const item of groups) {
        temp[item.k_group] = item.keterangan;
      }
      this.groups = temp;
    },

    onAdd() {
      this.$set(this.formulir, 'title', 'Tambah Data');
      this.$set(this.formulir, 'isChecked', false);
      this.$set(this.formulir, 'isEdit', false);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onUpload() {
      this.$refs.uploader.open();
    },

    async onEdit(item) {
      this.$set(this.formulir, 'isEdit', true);
      this.$set(this.formulir, 'isChecked', true);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'title', 'Ubah Data');
        this.$set(
          this.formulir,
          'init',
          Object.assign({}, item?.akun?.data ?? {}, { k_group: item.k_group, akun_instansi_id: item.akun_instansi_id })
        );
      });
    },

    onCheck(email) {
      this.$set(this.formulir, 'errorEmail', null);
      this.lookup(email)
        .then((resp) => {
          this.$set(this.formulir, 'isChecked', true);
          this.$set(this.formulir, 'init', this.$isObject(resp) ? resp : { email });
          this.$set(this.formulir, 'isExist', this.$isObject(resp));
        })
        .catch((resp) => {
          this.$set(this.formulir, 'isChecked', false);
          this.$set(this.formulir, 'init', {});
          this.$set(this.formulir, 'isExist', false);
          this.$set(this.formulir, 'errorEmail', resp.error || 'Pastikan anda memasukan data email yang Valid');
        });
    },

    onUncheck() {
      this.$set(this.formulir, 'isChecked', false);
      this.$set(this.formulir, 'init', {});
      this.$set(this.formulir, 'isExist', false);
    },

    onDelete(item) {
      this.$confirm(`Apakan anda ingin menghapus akun berikut?`, 'Hapus Akun', {
        tipe: 'error',
        data: this.confirmHtml(item),
      }).then(() => {
        this.action({ id: item.akun_instansi_id, type: 'delete' }).then(() => {
          this.$success('Akun berhasil di hapus');
          this.fetchData();
        });
      });
    },

    onAktif(item) {
      this.$confirm(`Apakan anda ingin mengaktifkan akun berikut?`, 'Aktifkan Akun', {
        tipe: 'warning',
        data: this.confirmHtml(item),
      }).then(() => {
        this.action({ id: item.akun_instansi_id, type: 'aktif' }).then(() => {
          this.$success('Akun berhasil diaktifkan');
          this.fetchData();
        });
      });
    },

    onNonAktif(item) {
      this.$confirm(`Apakan anda ingin menon-aktifkan akun berikut?`, 'Non-aktif Akun', {
        tipe: 'warning',
        data: this.confirmHtml(item),
      }).then(() => {
        this.action({ id: item.akun_instansi_id, type: 'blokir' }).then(() => {
          this.$success('Akun berhasil dinon-aktifkan');
          this.fetchData();
        });
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 40,
          iconColor: 'secondary',
          title: this.$getDeepObj(data, 'akun.data.nama') || '',
          subtitles: [`<span class="text--primary">${this.$getDeepObj(data, 'm_group.data.keterangan')}</span>`],
        },
      ];
    },

    onSave() {
      const isEdit = this.formulir.isEdit;
      const id = this.$refs.formulir.id;
      const params = Object.assign({}, this.$refs.formulir.getValue());

      this[isEdit ? 'update' : 'create']({ params, id })
        .then(({ data }) => {
          this.$success(`Data admin berhasil di ${isEdit ? 'diubah' : 'ditambahkan'}`);
          this.$refs.modal.close();
          this.fetchData();

          if (!isEdit && !this.formulir.isExist) {
            this.resetAkun(this.$getDeepObj(data, 'id'));
          }
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onReset(item) {
      const id = item.akun_instansi_id;
      this.$confirm(
        `Anda yakin ingin mereset password atas nama <strong>${item.akun?.data?.nama ?? ''}</strong> ?`,
        'Reset Password',
        {
          tipe: 'error',
        }
      ).then(() => {
        this.resetAkun(id);
      });
    },

    onSync(item) {
      this.$confirm(`Apakan anda ingin Sinkronisasi Admin ke eLearning ?`, 'Sinkronisasi Akun', {
        tipe: 'success',
        data: this.confirmHtml(item),
      }).then(() => {
        this.action({ id: item.akun_instansi_id, type: 'sinkronisasi' }).then(() => {
          this.$success('Akun berhasil disinkronisasi');
          this.fetchData();
        });
      });
    },

    resetAkun(id) {
      this.action({ id, type: 'reset' }).then(({ data, included }) => {
        const ptk = this.$getIncluded('akun', this.$getRelasi(data, 'akun')['id'], included);
        const group = this.$getIncluded('m_group', this.$getRelasi(data, 'm_group')['id'], included);
        this.$set(this.akun, 'nama', this.$getAttr(ptk, 'nama') || '-');
        this.$set(this.akun, 'email', this.$getAttr(ptk, 'email') || '-');
        this.$set(this.akun, 'password', this.$getAttr(ptk, 'passwd') || '*********');
        this.$set(this.akun, 'peran', (this.$getAttr(group, 'keterangan') || '-').toUpperCase());
        this.$nextTick(() => {
          this.$refs.akun.print();
        });
      });
    },

    filterStatus(filters) {
      // set filter
      this.filters = filters;
      Object.assign(this.params, { page: 1 });
      this.fetchData();
      this.$refs.filter.close();
    },

    unduhTemplate() {
      this.templateUpload().then((url) => {
        this.$downloadFile(process.env.VUE_APP_API_URL + '/' + url);
      });
    },

    unduhTokenTemplate() {
      this.downloadList({ url: 'download-aktivasi' }).then((url) => {
        this.$downloadFile(url);
      });
    },

    onDownload() {
      const M_LAPORAN = [
        {
          key: 'download',
          label: `Daftar Admin`,
          acl: this.$allow('psp-admin.download'),
        },
        {
          key: 'download-aktivasi',
          label: `Daftar Aktivasi Admin`,
          acl: this.$allow('psp-admin.download-aktivasi'),
        },
      ];

      let url = {};
      this.$confirm('Pilih jenis Berkas yang ingin di Unduh?', 'Unduh Berkas', {
        tipe: 'warning',
        form: {
          desc: 'Laporan Berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function(event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Laporan Berkas --'),
                M_LAPORAN.filter((laporan) => this.$allow(laporan.acl)).map((item) =>
                  h('option', { attrs: { value: item.key } }, item.label)
                ),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
        this.downloadList({ params, url: url.dokumen }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },

    uploadSave(data) {
      const formData = new FormData();
      for (let obj in data) {
        formData.append(obj, data[obj]);
      }

      const params = {
        params: formData,
      };

      this.upload(params)
        .then(({ data }) => {
          if (data && data.errors) {
            const error = Object.values(data.errors) || [];
            this.$refs.uploader.step = 1;
            this.$refs.uploader.errorFile.push(...error);
            return;
          }

          this.$refs.uploader.step = 1;
          this.fetchData();
        })
        .catch(() => {
          this.$error('Terdapat kesalahan saat mengunggah berkas, silakan periksa berkas Anda kemudian coba kembali!');
        });
    },
  },
};
